export const baseZIndex = 3

/**
 * not sure why, but the label cell takes 4
 * extra pixels wide and stretches out the
 * GridTable's scrollWidth by 4 pixels, so
 * we can offset it here
 */
export const MAGIC_NUMBER_TO_TAKE_OFF_WIDTH = 4
